import { api } from "./useApi";

export const produtoApi = () => ({
  getProduto: async (id: any) => {
    let response = await api.post("produto/unico", { id_produto: id });
    return response.data;
  },
  produtoCriar: async (produto: any) => {
    let response = await api.post("produto/criar", { produto });
    return response.data;
  },
  produtoInativar: async (id: any) => {
    let response = await api.post("produto/remover", { id_produto: id });
    return response.data;
  },
  gerarDescricaoIA: async (dados: any) => {
    let response = await api.post("produto/gerar_descricao_ia", dados);
    return response.data;
  },
  melhorarImagemIA: async (imagem: string) => {
    // Loga o essencial p/ depuração (sem despejar base64 no console).
    console.groupCollapsed("%c[IA] melhorar imagem", "color:#7c3aed;font-weight:bold");
    console.log("request →", {
      origem: imagem.startsWith("http") ? "url" : "base64",
      tamanho_aprox_bytes: imagem.length,
    });
    try {
      const response = await api.post("produto/melhorar_imagem_ia", { imagem });
      const { debug, success, error, tokens_usados } = response.data || {};
      console.log("response ←", { success, error, tokens_usados, debug });
      console.groupEnd();
      return response.data;
    } catch (err: any) {
      // Erros HTTP (>=400) também trazem o bloco debug no corpo.
      console.error("erro ←", err?.response?.data ?? err?.message ?? err);
      console.groupEnd();
      throw err;
    }
  },
  atualizarTokensUtilizados: async (tokensUsados: number) => {
    let response = await api.post("empresa/atualizar_tokens_ia", { tokens_usados: tokensUsados });
    return response.data;
  },
  statusTokensIA: async () => {
    let response = await api.post("empresa/status_tokens_ia");
    return response.data;
  }
});
 